<template>
  <div>
    <Alert type="warning" show-icon closable>
      远程面试操作须知
      <template slot="desc">
        1、请确认您已打开了声音和麦克风，并调至合适音量。
        <br>
        2、招聘会期间，请不要中途离开或关闭该页面，关闭页面会造成企业不在线状态，求职者将无法与您进行远程面试。
        <br>
        3、招聘会结束或您需要提前结束招聘，请退出该模块，请不要直接关机以免造成您在线状态异常。
        <br>
        4、请在右下“职位列表”功能区发布管理您的职位信息，“单位基础信息”功能区完善单位信息。
        <br>
        5、请在右上“求职者列表”选择您要面试的求职者，请务必完成所有面试申请。
        <br>
        6、单人面试时间为6分钟，超时将关闭面试通道，如提前完成面试，请在求职者画面下方点击红色挂断按钮结束面试。
      </template>

    </Alert>
    <Row :gutter="10">
      <i-col :md="6" :lg="6" style="margin-bottom: 10px;">
        <Card>
          <p slot="title">姓名：{{ pername }}</p>
          <video ref="playVideo" autoplay controls style="width: 100%;object-fit: inherit;"></video>
          <br>
          <div style="text-align: center;" v-if="room_state == 1">
            <el-button type="danger" icon="el-icon-phone-outline" circle @click="btnroomend"></el-button>
          </div>
        </Card>
        <h5 style="text-align:center; margin-top: 10px;font-size: 20px;">
          {{ addzero(hr) }}:{{ addzero(min) }}:{{ addzero(sec) }}</h5>
        <h5 style="text-align:center; margin-top: 5px;font-size: 20px;">网络面试室：{{ roomcount }}/{{ rooms }}</h5>
        <h5 style="text-align:center; margin-top: 5px;font-size: 20px;" v-if="roomcount == rooms">网络面试室拥堵，请耐心等待……</h5>
      </i-col>
      <i-col :md="18" :lg="18" style="margin-bottom: 10px;">
        <Row :gutter="10">
          <i-col :md="8" :lg="8" style="margin-bottom: 10px;">
            <Card>
              <p slot="title">单位名称：{{ formValidate_company.Cname }}</p>
<!--              <video-player-->
<!--                class="video-player vjs-custom-skin"-->
<!--                ref="localVideo"-->
<!--                :playsinline="true"-->
<!--                :options="playerOptions"/>-->
<!---->
              <video ref="localVideo" autoplay muted style="width: 100%;height:100%;object-fit: inherit;"></video>
            </Card>
          </i-col>
          <i-col :md="16" :lg="16" style="margin-bottom: 10px;">
            <Card>

              <p slot="title">求职者列表
                <!--            <i @click="playVoice" class="el-icon-microphone"></i>-->
                <!--            <section v-if="duration != '0'" @click="playVoice" class="qj_audio">-->
                <!--              <span class="voice-normal" :class="{ voicePlay: isPlay }"></span>-->
                <!--              <span> {{ duration }} </span>-->
                <!--            </section>-->
                <span style="float:right;" ><span v-if="count_per > 0">
                  <el-divider direction="vertical"></el-divider>招聘会现场人数：<span
                  style="font-size:20px;color: #ed4014;" >{{ count_per }}</span></span>
                <el-divider direction="vertical"></el-divider>总人数：<span
                  style="font-size:20px;color: #ed4014;">{{ count_all }}</span>
                <el-divider direction="vertical"></el-divider>待面试：<span
                  style="font-size:20px;color: #ed4014;">{{ count_wait }}</span>
                <el-divider direction="vertical"></el-divider>已面试：<span
                  style="font-size:20px;color: #ed4014;">{{ count_end }}</span>
                <el-divider direction="vertical"></el-divider>面试开关：
              <i-switch size="small" v-model="ms_switch" @on-change="msallow">

              <span slot="open"></span>
              <span slot="close"></span>
            </i-switch>
                <el-divider direction="vertical"></el-divider>消息开关：
                <i-switch size="small" v-model="ms_voice" @on-change="voiceoff">

                  <span slot="open"></span>
                  <span slot="close"></span>
                </i-switch></span>

              </p>
              <Table size="small" ref="table_in" border :columns="columns_in" :data="tableData_in" height="285"
                     @on-selection-change="handleSelectChange"></Table>
            </Card>
          </i-col>
        </Row>
        <Row :gutter="10">
          <i-col :md="6" :lg="6" style="margin-bottom: 10px;">
            <Card>
              <p slot="title">单位基础信息</p>
              <Form ref="formValidate_company" :model="formValidate_company" :label-width="80">

                <FormItem
                  label="单位简介"
                  prop="Cintroduce"
                >
                  <Input
                    type="textarea"
                    v-model="formValidate_company.Cintroduce"
                    :rows="8"
                    placeholder="请输入公司简介"
                  ></Input>

                </FormItem>
                <FormItem label="联系人" prop="Ccontacts">
                  <Input
                    v-model="formValidate_company.Ccontacts"
                    placeholder="请输入"
                  ></Input>
                </FormItem>

                <FormItem label="联系方式" prop="Cphone">
                  <Input
                    v-model="formValidate_company.Cphone"
                    placeholder="请输入"
                  ></Input>
                </FormItem>

                <FormItem>
                  <Button
                    type="primary"
                    @click="handleSubmit_company('formValidate_company')"
                  >更新
                  </Button>

                </FormItem>

              </Form>
            </Card>
          </i-col>
          <i-col :md="18" :lg="18" style="margin-bottom: 10px;">
            <Card>
              <p slot="title">职位列表</p>
              <div class="search-con search-con-top">

                <slot name="new_btn">
                  <Button type="primary" @click="editModal('', 'post', '添加职位')" class="search-btn">添加职位</Button>
                </slot>
                <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
                <Button type="success" class="search-btn" @click="handlerUp">批量启用</Button>
              </div>
              <Table size="small" ref="table_job" border :columns="columns_job" :data="tableData_job" height="286"
                     @on-selection-change="handleSelectChange"></Table>
              <div style="margin: 10px; overflow: hidden">
                <div style="float: left;">
                  <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[5,15,35,50,100]
                        show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
                  </Page>
                </div>
              </div>
            </Card>
          </i-col>
        </Row>
      </i-col>
    </Row>

    <Spin size="large" fix v-if="spinShow"></Spin>

    <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
           :mask-closable=false>
      <Form ref="formValidate_job" :model="formValidate_job" :rules="ruleValidate" :label-width="100">

        <FormItem
          label="职位名称"
          prop="Jobname"
        >
          <Input
            v-model="formValidate_job.Jobname"
            placeholder="请输入"
          ></Input>

        </FormItem>
        <FormItem
          label="职位类别"
          prop="Jabbreviation"
        >
          <el-cascader
            v-model="formValidate_job.Jabbreviation"
            placeholder="请选择"
            :options="JabbreviationList"
            filterable
            clearable></el-cascader>
        </FormItem>
        <FormItem
          label="职位描述"
          prop="Jdescribe"
        >
          <Input
            type="textarea"
            v-model="formValidate_job.Jdescribe"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem
          label="招聘人数"
          prop="Jnum"
        >
          <Input
            v-model="formValidate_job.Jnum"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem label="工作经验" prop="Jexperience">
          <el-select
            v-model="formValidate_job.Jexperience"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJexperienceList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem label="学历" prop="Jeducation">
          <el-select
            v-model="formValidate_job.Jeducation"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJeducationList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem label="薪资" prop="Jsalary">
          <el-select
            v-model="formValidate_job.Jsalary"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJsalaryList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem label="性别" prop="Jsex">
          <el-select
            v-model="formValidate_job.Jsex"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJsexList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem label="年龄" prop="Jage">
          <el-select
            v-model="formValidate_job.Jage"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJageList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem label="婚姻" prop="Jmarriage">
          <el-select
            v-model="formValidate_job.Jmarriage"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJmarriageList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem
          label="其他要求"
          prop="Jrequirement"
        >
          <Input
            type="textarea"
            v-model="formValidate_job.Jrequirement"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem
          label="工作地址"
          prop="Jaddress"
        >
          <Input
            v-model="formValidate_job.Jaddress"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem label="开始时间" prop="Jstime">
          <DatePicker type="date" editable v-model="formValidate_job.Jstime" format="yyyy-MM-dd" placement="bottom-end"
                      placeholder="请选择开始时间"></DatePicker>
        </FormItem>

        <FormItem label="结束时间" prop="Jetime">
          <DatePicker type="date" editable v-model="formValidate_job.Jetime" format="yyyy-MM-dd" placement="bottom-end"
                      placeholder="请选择开始时间"></DatePicker>
        </FormItem>

        <FormItem label="类型" prop="Jtype">
          <el-select
            v-model="formValidate_job.Jtype"
            filterable

            default-first-option
            placeholder="请选择">
            <el-option
              v-for="item in jobJtypeList"
              :key="item.value"
              :label="item.meaning"
              :value="item.value">
            </el-option>
          </el-select>
        </FormItem>
        <FormItem
          label="联系人"
          prop="Jlinkman"
        >
          <Input
            v-model="formValidate_job.Jlinkman"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem
          label="联系电话"
          prop="Jphone"
        >
          <Input
            v-model="formValidate_job.Jphone"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit_job('formValidate_job')"
          >提交
          </Button>

        </FormItem>

      </Form>
    </Modal>
    <el-drawer
      title="个人信息"
      :visible.sync="msgmodal"
      direction="ltr"
      size="30%">
      <el-divider></el-divider>
        <el-form ref="form" :model="formValidate_per" label-width="100px">

          <el-form-item label="姓名：">
            {{ formValidate_per.Pname }}
          </el-form-item>
          <el-form-item label="性别：">
            {{ formValidate_per.Psex_CN }}
          </el-form-item>
          <el-form-item label="年龄：">
            {{ formValidate_per.age }}
          </el-form-item>
          <el-form-item label="身份证：">
            {{ formValidate_per.Perinfo.Pidcard }}
          </el-form-item>
          <el-form-item label="地址：">
            {{ formValidate_per.Perinfo.Paddress }}
          </el-form-item>
          <el-form-item label="现居住区域：">
            {{ formValidate_per.Pnowaddress }}
          </el-form-item>
          <el-form-item label="电话：">
            {{ formValidate_per.Perinfo.Pphone }}
          </el-form-item>
          <el-form-item label="婚姻：">
            {{ formValidate_per.Pmarriage_CN }}
          </el-form-item>
          <el-form-item label="民族：">
            {{ formValidate_per.Pnation_CN }}
          </el-form-item>
          <el-form-item label="学历：">
            {{ formValidate_per.Peducation_CN }}
          </el-form-item>
          <el-form-item label="工作年限：">
            {{ formValidate_per.Pexperience_CN }}
          </el-form-item>

          <el-form-item label="期望薪酬：">
            {{ formValidate_per.Psalary_CN }}
          </el-form-item>
          <el-form-item label="简历：">
          <el-image
            style="width: 100px; height: 100px"
            :src="formValidate_per.perpic"
            :preview-src-list="formValidate_per.perpiclist">
          </el-image>
          </el-form-item>

        </el-form>
    </el-drawer>

  </div>
</template>

<script>

import {
  changePer,
  getCompanyinfo,
  getjoblist,
  getperjob,
  operationcompanyinfo,
  operationjob,
  changeJob,
  getroomstate,
  changecompanystate,
  roomok,
  changecompanyonline,
  getroomrand,
  roomchange,
  getsdk,
  getjobstypeList
} from '@/api/apply/apply.js'
import { ZegoExpressEngine } from 'zego-express-engine-webrtc'
import { getsysparameterList } from '@/api/system/sys_parameter'
import $ from 'jquery'
import md5 from 'md5'
import { forEach } from '../../libs/tools'

// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      time_do: 0,
      jobfair: {},
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: '/api/project/getPlayResource/25' // url地址
        }],
        poster: '', // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },

        audio:
        '../test.pcm', // 语音文件地址
      duration: '0', // 语音的时长
      source: null, // AudioBuffer 对象 进行开始和停止语音
      sounds: null, // 获取的音频数据
      isPlay: false, // 语音是否在播放
      words: '您有新的面试请求',
      go_down: 1,
      go_up: 1,
      _beforeUnload_time: 0,
      _gap_time: 0,
      ms_state: false,
      ms_switch: true,
      ms_voice: true,
      count_all: 0,
      count_per: 0,
      count_wait: 0,
      count_end: 0,
      pername: '---',
      playsteamid: '',
      msgtype: 1,
      msgtit: '面试室消息',
      msgcon1: '现场求职者未响应',
      msgcon2: '是否确认退出？',
      msgbtn: '退出',
      msgmodal: false,
      modal_loading: false,
      zg_now: '',
      room_state: 0, // 0:等待，1：面试
      day: 0, // 天
      hr: 0, // 时
      min: 0, // 分
      sec: 0, // 秒
      roomcount: 0,
      rooms: 0,
      room_id: '',
      room_finfo: {
        Roomid: '',
        State: 0,
        Istime: '',
        Ietime: '',
        Icomid: '',
        Iperid: '',
        Iresult: '',
        Aid: ''
      },
      getstream: '',
      jobfair_info: this.$route.query.jobfair_id,
      disableJoin: false,
      ptream: MediaStream,
      previewStream: MediaStream,
      localStream: null,
      remoteStreams: [],
      spinShow: false,
      fullscreenLoading: false,
      jobstateList: [],
      jobJexperienceList: [],
      JabbreviationList: [],
      jobJeducationList: [],
      jobJsalaryList: [],
      jobJsexList: [],
      jobJageList: [],
      jobJstateList: [],
      jobJtypeList: [],
      jobJmarriageList: [],
      formValidate_company: {},
      formValidate_per: {
        Perinfo: {}
      },
      formValidate_job: {},
      streamList: [],
      formValidate: {
        Id: 0,
        Mid: 0,
        Jname: '',
        Jstime: '',
        Jtype: 0,
        Jetime: '',
        Jstate: 0
      },
      option: {
        camera: {
          audioBitrate: 48,
          videoQuality: 1,
          width: 320,
          height: 240,
          frameRate: 15,
          bitrate: 300
        }
      },
      sdk_appid: '1018017038',
      sdk_appsign: 'acc155a6eba91d9f329a18c27201918a5d5185ce080b1781f2259ad54d071c73',
      sdk_url: 'wss://webliveroom-test.zego.im/ws',
      sdk_server: 'wss://webliveroom1018017038-api.zego.im/ws',
      searchVal: '',
      tableData: [],
      tableData_in: [],
      tableData_job: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 5, // 每页条数

      ruleValidate: {
        // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
        Jobname: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur'
          }
        ],
        Jabbreviation: [
          {
            type: 'array',
            required: true,
            message: '请选择工种',
            trigger: 'blur'
          }
        ],
        Jnum: [
          {
            required: true,
            message: '招聘人数不能为空',
            trigger: 'blur'
          }
        ],
        Jexperience: [
          {
            required: true,
            message: '请选择工作经验',
            trigger: 'change'
          }
        ],
        Jeducation: [
          {
            required: true,
            message: '请选择学历',
            trigger: 'change'
          }
        ],
        Jsalary: [
          {
            required: true,
            message: '请选择薪资',
            trigger: 'change'
          }
        ],
        Jsex: [
          {
            required: true,
            message: '请选择性别要求',
            trigger: 'change'
          }
        ],
        Jage: [
          {
            required: true,
            message: '请选择年龄要求',
            trigger: 'change'
          }
        ],
        Jmarriage: [
          {
            required: true,
            message: '请选择婚姻要求',
            trigger: 'change'
          }
        ],
        Jaddress: [
          {
            required: true,
            message: '工作地址不能为空',
            trigger: 'blur'
          }
        ],
        Jstime: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        Jetime: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change'
          }
        ],
        Jtype: [
          {
            required: true,
            message: '请选择职位类型',
            trigger: 'change'
          }
        ],
        Jphone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }
        ],
        Jlinkman: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ]

      },
      columns_in: [
        {
          type: 'selection',
          key: 'Id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '姓名',
          key: 'Pname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 100
        },
        {
          title: '性别',
          key: 'Psex_CN',
          align: 'center',
          sortable: true,
          width: 80
        },
        {
          title: '学历',
          key: 'Peducation_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '工作经验',
          key: 'Pexperience_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '应聘岗位',
          key: 'Jobname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 140
        },
        {
          title: '状态',
          key: 'handle',
          width: 110,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: params.row.Astate_col } }, params.row.Astate_CN)
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let that = this
            if (this.ms_state) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'info',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        that.perinfo_show(params.row)
                      }
                    }
                  },
                  '查看简历'
                )
              ])
            } else {
              if (this.jobfair.Jauth.substr(0, 1) == '1' && params.row.Aneedsee == 1) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '100px'
                      },
                      on: {
                        click: () => {
                          this.roomin(params.row)
                        }
                      }
                    },
                    '邀请面试'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'warning',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          that.perinfo_show(params.row)
                        }
                      }
                    },
                    '简历'
                  )
                ])
              } else {
                if (params.row.Aneedsee == 1 && ((params.row.rownum == 1 && params.row.Astate == 1) || params.row.Astate == 5 || params.row.Astate == 6) && this.rooms > this.roomcount) {
                  return h('div', [
                    h(
                      'Button',
                      {
                        props: {
                          type: 'primary',
                          size: 'small'
                        },
                        style: {
                          marginRight: '5px'
                        },
                        on: {
                          click: () => {
                            this.roomin(params.row)
                          }
                        }
                      },
                      '邀请面试'
                    ),
                    h(
                      'Button',
                      {
                        props: {
                          type: 'warning',
                          size: 'small'
                        },
                        style: {
                          marginRight: '5px'
                        },
                        on: {
                          click: () => {
                            that.perinfo_show(params.row)
                          }
                        }
                      },
                      '简历'
                    )
                  ])
                } else if (params.row.Aneedsee == 1 && params.row.Astate == 1) {
                  return h('div', [
                    h('Tag', { props: { color: 'blue' } }, '等待面试'),
                    h(
                      'Button',
                      {
                        props: {
                          type: 'warning',
                          size: 'small'
                        },
                        style: {
                          marginRight: '5px'
                        },
                        on: {
                          click: () => {
                            that.perinfo_show(params.row)
                          }
                        }
                      },
                      '简历'
                    )
                  ])
                } else {
                  return h('div', [
                    h(
                      'Button',
                      {
                        props: {
                          type: 'info',
                          size: 'small'
                        },
                        style: {
                          marginRight: '5px'
                        },
                        on: {
                          click: () => {
                            that.perinfo_show(params.row)
                          }
                        }
                      },
                      '查看简历'
                    )
                  ])
                }
              }
            }
          }
        }
      ],
      columns_job: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '职位名称',
          key: 'Jobname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 250
        },
        {
          title: '人数',
          key: 'Jnum',
          align: 'center',
          sortable: true,
          width: 80
        },
        {
          title: '性别',
          key: 'Jsex_CN',
          align: 'center',
          sortable: true,
          width: 100
        },
        {
          title: '学历',
          key: 'Jeducation_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '工作经验',
          key: 'Jexperience_CN',
          align: 'center',
          sortable: true,
          width: 150
        },

        {
          title: '薪资',
          key: 'Jsalary_CN',
          align: 'center',
          sortable: true,
          width: 150
        },
        {
          title: '状态',
          key: 'handle',
          width: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: params.row.Jstate_col } }, params.row.Jstate_CN)
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            if (params.row.Jstate == 1) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '暂停'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            } else {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changstate(params.row)
                      }
                    }
                  },
                  '启用'
                ),

                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        }
      ]
    }
  },

  destroyed () {
    window.removeEventListener('beforeunload', e =>
      this.beforeunloadHandler(e)
    )
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  beforeDestroy () {
    changecompanyonline(this.formValidate_company, 'POST').then(res => {
      if (res.data.code === 0) {
      } else {
        this.$Message.error(`${res.data.msg}`)
      }
    })

    this.room_finfo.State = 1
    try {
      this.zg_now.logoutRoom(this.room_id)
      this.room_id = 0
    } catch (e) {

    }
    // this.zg_now.logoutRoom(this.room_id)
  },
  beforeRouteLeave (to, from, next) {
    this.$confirm('即将离开在线招聘会，是否确定离开?', '提示', {
      distinguishCancelAndClose: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(() => {
      changecompanyonline(this.formValidate_company, 'POST').then(res => {
        if (res.data.code === 0) {
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })

      this.room_finfo.State = 1
      try {
        this.zg_now.logoutRoom(this.room_id)
        this.room_id = 0
      } catch (e) {

      }
      next()
    }).catch(action => {
      if (action === 'cancel') {

      }
    })
  },
  methods: {

    setDuration () {
      // 问号后面的是语音时长 这里的语音时长 是服务器接口返回的
      let last = this.audio.split('?')[1]
      try {
        if (last != 0) {
          // 因为我们的语音 最长不会超过60秒 所以只做了秒的判断
          if (last < 10) {
            last = '0' + last
          }
          this.duration = '00:' + last
        }
      } catch (error) {
        console.log(error)
      }
    },
    playVoice () {
      var _this = this
      // console.log(this.ms_voice)
      if (this.ms_voice) {
        // console.log(this.isPlay)

        if (this.isPlay) {
          //   关闭语音
          // console.log('1')
          this.stopVoice()
        } else {
          _this.isPlay = true
          // console.log('2')
          //   播放语音
          if (this.sounds == null) {
            // console.log('2-1')
            // 首次加载语音文件
            var req = new XMLHttpRequest()
            req.open('GET', this.audio, true)

            req.overrideMimeType('text\/plain; charset=x-user-defined')
            req.onreadystatechange = function (aEvt) {
              if (req.readyState == 4) {
                if (req.status == 200) {
                  _this.sounds = req.responseText
                  _this.startVoice(_this)
                } else {
                  // window.ToastShow("failed loading audio");
                }
              }
            }
            req.send(null)
          } else {
            // 直接播放
            // console.log('3')
            _this.startVoice(_this)
          }
        }
      }
    },
    stopVoice () {
      this.source.stop()
      this.isPlay = false
    },
    startVoice (_this) {
      // Stereo 这里的逻辑没有进行深入研究 直接拿过来用了
      var channels = 1
      var audioCtx = new (window.AudioContext || window.webkitAudioContext)()

      // Create an empty two second stereo buffer at the
      // sample rate of the AudioContext
      var frameCount = _this.sounds.length / 2

      var myAudioBuffer = audioCtx.createBuffer(channels, frameCount, 16000)
      for (var channel = 0; channel < channels; channel++) {
        var nowBuffering = myAudioBuffer.getChannelData(channel, 16, 16000)
        for (var i = 0; i < frameCount; i++) {
          // audio needs to be in [-1.0; 1.0]
          // for this reason I also tried to divide it by 32767
          // as my pcm sample is in 16-Bit. It plays still the
          // same creepy sound less noisy.
          var word =
            (_this.sounds.charCodeAt(i * 2) & 0xff) +
            ((_this.sounds.charCodeAt(i * 2 + 1) & 0xff) << 8)
          nowBuffering[i] = (((word + 32768) % 65536) - 32768) / 32768.0
        }
      }
      // Get an AudioBufferSourceNode.
      // This is the AudioNode to use when we want to play an AudioBuffer
      var sources = audioCtx.createBufferSource()
      // set the buffer in the AudioBufferSourceNode
      sources.buffer = myAudioBuffer
      // connect the AudioBufferSourceNode to the
      // destination so we can hear the sound
      sources.connect(audioCtx.destination)
      // start the source playing
      sources.start()

      // When the buffer source stops playing, disconnect everything

      sources.onended = function () {
        _this.isPlay = false

        console.log('ended')

        sources.disconnect(audioCtx.destination)
      }

      _this.source = sources
    },
    reader () {
      let readWords = this.words // 获取播报的文字（除去样式）
      var url = 'http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&text=' + encodeURI(readWords)
      var n = new Audio(url)
      n.src = url
      n.play() // 播放阅读

//  n.cancel();  //取消阅读
//  n.pause();  //暂停阅读
    },
    unloadHandler (e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      console.log(this._gap_time)
      // 判断是窗口关闭还是刷新
      localStorage.setItem('time', this._gap_time)
      if (this._gap_time <= 5) {
        changecompanyonline(this.formValidate_company, 'POST').then(res => {
          if (res.data.code === 0) {
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    beforeunloadHandler (e) {
      this._beforeUnload_time = new Date().getTime()

      this.room_finfo.State = 1
      try {
        this.zg_now.logoutRoom(this.room_id)
        this.room_id = 0
      } catch (e) {

      }
    },
    msg (type) {
      if (type == 1) {
        this.msgmodal = false
        this.sec = 0
        this.min = 0
        this.hr = 0
        this.$refs.localVideo.pause()
        this.$refs.localVideo.srcObject = null
        // await this.zg_now.stopPlayingStream(this.playsteamid)
        this.zg_now.logoutRoom(this.room_id)
        this.room_id = 0
      }
      if (type == 2) {
        this.msgmodal = false
        this.sec = 0
        this.min = 0
        this.hr = 0

        this.$refs.localVideo.pause()
        this.$refs.localVideo.srcObject = null
        this.$refs.playVideo.pause()
        this.$refs.playVideo.srcObject = null
        this.zg_now.logoutRoom(this.room_id)
        this.room_id = 0
        this.room_state = 0
        this.getroomstate()
        // that.getjoblist()
      }
    },

    voiceoff () {
      console.log(this.ms_voice)

      if (!this.ms_voice) {
        this.stopVoice()
      }
    },
    msallow () {
      if (this.ms_switch) {
        this.formValidate_company.Cinterviewallow = 0
      } else {
        this.formValidate_company.Cinterviewallow = 1
      }
      changecompanystate(this.formValidate_company, 'POST').then(res => {
        if (res.data.code === 0) {
          // this.roomcount = res.data.count
          // this.rooms = res.data.maxcount
          this.$Message.success(`${res.data.msg}`)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getroomstate () {
      const that = this
      getroomstate(2).then(res => {
        if (res.data.code === 0) {
          this.roomcount = res.data.count
          this.rooms = res.data.maxcount
        } else {
          // this.$Message.error(`${res.data.msg}`)
        }
      })
      that.getperjob(that.formValidate_company.Id)
      // that.getjoblist()
      if (that.room_id == 0) {
        setTimeout(function () {
          that.getroomstate()
        }, 30000)
      }
    },
    countdown () {
      this.sec = this.sec + 1
      if (this.sec > 59) {
        this.sec = 0
        this.min = this.min + 1
        if (this.room_state == 0 && this.min % 2 == 0) { // 等待时间到，自己退出
          this.go_down = 0
          this.$confirm('求职者未响应面试, 是否退出面试室?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.msg(1)
          }).catch(() => {
            this.go_down = 1
            this.countdown()
          })
        }
        if (this.min > 59) {
          this.min = 0
          this.hr = this.hr + 1
        }
      }
      const that = this
      if (this.go_down == 1) {
        setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },
    countup () {
      this.time_do = 1

        if (this.sec == 0) {
          if (this.min == 0) {
            this.go_up = 0
            this.$confirm('面试时间到，将中断面试?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.btnroomend()
            }).catch(() => {
              this.btnroomend()
            })
          } else {
            this.sec = 59
            this.min = this.min - 1
          }
        } else {
          this.sec = this.sec - 1
        }
        const that = this
        if (this.go_up == 1) {
          setTimeout(function () {
            that.countup()
          }, 1000)
      }
    },
    // 获取TagTree

    getcompanyinfo (value) {
      this.spinShow = true
      getCompanyinfo(value).then(res => {
        if (res.data.code === 0) {
          this.formValidate_company = res.data.data
          if (this.formValidate_company.Cinterviewallow == 0) {
            this.ms_switch = true
          } else {
            this.ms_switch = false
          }

          this.getroomstate()
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getperjob (Cid) {
      // this.spinShow = true
      // console.log(this.jobfair_info.Id)
      let that = this
      getperjob(Cid, this.jobfair_info).then(res => {
        if (res.data.code === 0) {
          this.tableData_in = res.data.data
          this.count_all = res.data.count_all
          this.count_wait = res.data.count_wait
          this.count_end = res.data.count_end
          this.count_per = res.data.count_per
          this.jobfair = res.data.jobfair
          // console.log(this.jobfair)
          res.data.data.forEach(function (item) {
            if (item.roomwait && that.room_id == 0) {
              that.room_id = -1
              that.$confirm('有用户向您发起的面试请求?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '同意',
                cancelButtonText: '不同意',
                type: 'warning',
                center: true
              }).then(() => {
                // that.$Message.error(`${item.roomwait.Roomid}`)
                that.room_id = item.roomwait.Roomid
                that.room_state = 0
                that.room_finfo.Roomid = item.roomwait.Roomid
                that.room_finfo.Iperid = item.roomwait.Iperid
                that.pername = item.Perinfo.Pname
                that.room_finfo.Icomid = that.formValidate_company.Id
                that.room_finfo.Aid = item.Id
                // that.videostart(item.roomwait.Roomid)
                that.videoin(item.roomwait.Roomid)
                // that.getroomstate()
              }).catch(action => {
                if (action === 'cancel') {
                  that.room_id = 0
                }
              })
            }
          })

          if (this.count_wait > 0 && this.room_id == 0) {
            // console.log('放声音')
            this.playVoice()
          }
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        // this.spinShow = false
      })
    },

    getsdk (sdk, roomid) {
      // this.spinShow = true
      // console.log(this.jobfair_info.Id)
      getsdk(sdk, roomid).then(res => {
        if (res.data.code === 0) {
          this.sdk_appid = res.data.data.appid
          this.sdk_appsign = res.data.data.appsign
          this.sdk_server = res.data.data.severurl
          try {
            this.zg_now.logoutRoom(this.room_id)
          } catch (e) {

          } finally {
            this.videostart(this.room_id)
          }
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        // this.spinShow = false
      })
    },

    getjoblist (key, value) {
      this.spinShow = true

      getjoblist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.tableData_job = res.data.data
          this.pageTotal = res.data.count
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    handleSubmit_job (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.formValidate_job.Jstime = moment(this.formValidate_job.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
          this.formValidate_job.Jetime = moment(this.formValidate_job.Jetime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
          // this.formValidate_job.Jid = this.jobfair_info
          setTimeout(() => {
            operationjob(this.formValidate_job, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getjoblist()
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('请填写完整信息')
        }
      })
    },
    handleSubmit_company (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            operationcompanyinfo(this.formValidate_company, 'POST').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getcompanyinfo()
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('请填写完整信息')
        }
      })
    },
    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },
    getjobspapamsList () {
      getsysparameterList('job_info', 'Jexperience').then(res => {
        if (res.data.code === 0) {
          this.jobJexperienceList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jeducation').then(res => {
        if (res.data.code === 0) {
          this.jobJeducationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsalary').then(res => {
        if (res.data.code === 0) {
          this.jobJsalaryList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jsex').then(res => {
        if (res.data.code === 0) {
          this.jobJsexList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jage').then(res => {
        if (res.data.code === 0) {
          this.jobJageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jmarriage').then(res => {
        if (res.data.code === 0) {
          this.jobJmarriageList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('job_info', 'Jtype').then(res => {
        if (res.data.code === 0) {
          this.jobJtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getjobstypeList (value, level) {
      getjobstypeList(value, level).then(res => {
        if (res.data.code === 0) {
          this.JabbreviationList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSearch () {
      this.getjoblist(this.searchVal)
    },
    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getjoblist(this.searchVal)
      } else {
        this.getjoblist()
      }
    },
    changstate (paramsRow) {
      setTimeout(() => {
        changeJob(paramsRow, 'PUT').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.getjoblist()
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }, 1000)
    },
    handlerUp () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量启用这些职位 `)) {
          changeJob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getjoblist()
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    handlerDelete () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中职位 `)) {
          operationjob({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getjoblist()
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    // 删除
    delData (params) {
      if (confirm(`确定要删除 ${params.row.Jobname}`)) {
        // console.log(params.row.id)
        operationjob(
          {
            'id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData_job.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getjobspapamsList()
      this.getjobstypeList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.Id) {
        this.formValidate_job = {
          Id: paramsRow.Id,
          Jobname: paramsRow.Jobname,
          Jabbreviation: paramsRow.Jabbreviation,
          Jdescribe: paramsRow.Jdescribe,
          Jnum: paramsRow.Jnum,
          Jexperience: paramsRow.Jexperience,
          Jeducation: paramsRow.Jeducation,
          Jsalary: paramsRow.Jsalary,
          Jsex: paramsRow.Jsex,
          Jage: paramsRow.Jage,
          Jrequirement: paramsRow.Jrequirement,
          Jaddress: paramsRow.Jaddress,
          Jstate: paramsRow.Jstate,
          Jstime: paramsRow.Jstime,
          Jetime: paramsRow.Jetime,
          Jtype: paramsRow.Jtype,
          Jlinkman: paramsRow.Jlinkman,
          Jphone: paramsRow.Jphone,
          Jmarriage: paramsRow.Jmarriage,
          Juid: paramsRow.Juid,
          Jcid: paramsRow.Jcid,
          Jid: this.jobfair_info

        }
      } else {
        this.formValidate_job = {
          Id: 0,
          Jobname: '',
          Jabbreviation: '',
          Jdescribe: '',
          Jnum: '',
          Jexperience: '',
          Jeducation: '',
          Jsalary: '',
          Jsex: '',
          Jage: '',
          Jrequirement: '',
          Jaddress: this.formValidate_company.Caddress,
          Jstime: '',
          Jetime: '',
          Jtype: '',
          Jlinkman: this.formValidate_company.Ccontacts,
          Jphone: this.formValidate_company.Cphone,
          Jmarriage: '',
          Juid: this.formValidate_company.Cuid,
          Jcid: this.formValidate_company.Id,
          Jid: this.jobfair_info
        }
      }
    },
    getZeGouToken (appId, appSign, userID) {
      let nonce = new Date().getTime().toString()
      let time = Math.floor(new Date().getTime() / 1000 + 30 * 60)
      let appSign32 = appSign.replace(/0x/g, '').replace(/,/g, '').substring(0, 32)
      // console.log ('appSign:' + time + '    ' + appSign32 + '    ' + nonce);

      if (appSign32.length < 32) {
        // console.log ('private sign erro!!!!');
        return null
      }

      let sourece = md5(appId + appSign32 + userID + nonce + time)
      //  console.log ('hash:' + sourece);

      let jsonStr = JSON.stringify({
        'ver': 1,
        'expired': time,
        'nonce': nonce,
        'hash': sourece
      })
      // console.log ('json', jsonStr);
      return Buffer.from(jsonStr).toString('base64')
    },
    roomin (params) {
      let that = this
      let perid = params.Perinfo.Id
      let aid = params.Id
      getroomrand(1, perid, this.formValidate_company.Id, params.Ajobid, aid).then(res => {
        if (res.data.code === 0) {
          let room_noman = res.data.count
          if (room_noman > 0) {
            this.room_id = res.data.randroom

            this.room_state = 0
            this.room_finfo.Roomid = res.data.randroom
            this.room_finfo.Iperid = perid
            this.pername = params.Perinfo.Pname
            this.room_finfo.Icomid = this.formValidate_company.Id
            this.room_finfo.Aid = aid
            this.room_finfo.Iresult = ''
            // this.room_finfo.State = 0
            that.videostart(res.data.randroom)
            that.getroomstate()
          } else {
            this.$Message.error('暂无可用远程面试室，请稍后再试')
          }
        } else if (res.data.code === -2) {
          this.$confirm(res.data.msg + '是否将其放置队列末尾，稍后再面试?', '选择', {
            confirmButtonText: '稍后再面试',
            cancelButtonText: '继续等待',
            type: 'warning'
          }).then(() => {
            changePer(aid, 'POST').then(res => {
              if (res.data.code === 0) {
                that.getroomstate()
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }).catch(() => {
            this.getroomstate()
          })
        } else if (res.data.code === -3) {
          this.$confirm(res.data.msg + '是否重新进入?', '选择', {
            confirmButtonText: '重新进入',
            cancelButtonText: '退出',
            type: 'warning'
          }).then(() => {
            this.room_id = res.data.data.Roomid
            this.room_state = 0
            this.room_finfo.Roomid = res.data.data.Roomid
            this.room_finfo.Iperid = perid
            this.pername = params.Perinfo.Pname
            this.room_finfo.Icomid = this.formValidate_company.Id
            this.room_finfo.Aid = aid
            that.videostart(res.data.data.Roomid)
            that.getroomstate()
          }).catch(() => {
            this.roomout()
          })
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    roomout () {
      let that = this
      roomchange(this.room_finfo).then(res => {
        if (res.data.code === 0) {
          that.getroomstate()
          // that.getperjob(that.formValidate_company.Id)
        } else {
          // this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    roomok () {
      let that = this
      roomok(this.room_finfo).then(res => {
        if (res.data.code === 0) {
          that.getroomstate()
          // that.getperjob(that.formValidate_company.Id)
        } else {
          // this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    async videoin (roomID) {
      // this.$Message.error(`${roomID}`)
      let appID = parseInt(this.sdk_appid)
      let aoosign = this.sdk_appsign
      let server = this.sdk_server
      console.log(appID + '|' + aoosign + '|' + server)
      let userID = this.formValidate_company.Id.toString()
      let userName = this.formValidate_company.Id.toString()
      let token = ''
      let streamID = this.formValidate_company.Id.toString()
      let that = this
      let zg = ''
      if (this.zg_now == '') {
        zg = new ZegoExpressEngine(appID, server)
        this.zg_now = zg
        console.log('sse-' + this.zg_now)
      } else {
        zg = this.zg_now
        console.log('sse-' + this.zg_now)
      }
      this.zg_now = zg
      zg.on('roomStateUpdate', async (roomID, state, errorCode, extendedData) => {
        if (state == 'DISCONNECTED') {
          // 与房间断开了连接
          that.ms_state = false
          this.roomout()
        }
        if (state == 'CONNECTING') {
          // 与房间尝试连接中
        }
        if (state == 'CONNECTED') {
          // 与房间连接成功
          that.ms_state = true
          const stream = await zg.createStream(this.option)

          this.$refs.localVideo.srcObject = stream
          // this.playerOptions.sources[0].src = stream;

          // console.log(stream)
          const repush = zg.startPublishingStream(streamID, stream)
          console.log('推流：' + repush)
          // this.$Message.error('推流：'+repush)
          if (!repush) {
            this.$Message.error('视频信号传输失败，更换线路')
            this.$confirm('视频服务接入失败，请确认您的网络线路，是否更换线路再次尝试连接?', '选择', {
              distinguishCancelAndClose: true,
              confirmButtonText: '大陆线路',
              cancelButtonText: '港澳台或海外线路',
              type: 'warning',
              center: true
            }).then(() => {
              this.getsdk(1, this.room_id)
            }).catch(action => {
              if (action === 'cancel') {
                this.getsdk(2, this.room_id)
              } else {
                this.go_down = 0
                this.go_up = 0
                this.sec = 0
                this.min = 0
                this.hr = 0
                this.zg_now.logoutRoom(this.room_id)
                this.room_id = 0
                this.$router.push({
                  name: 'apply_jobfair'
                })
              }
            })
          }
        }
      })
      token = this.getZeGouToken(appID, aoosign, userID)
      const result = await zg.loginRoom(roomID, token, { userID, userName })
      console.log('登录房间' + result)
      if (!result) {
        this.$Message.error('登录失败')
      }
      zg.on('publisherStateUpdate', result => {
// 推流状态变更通知
        console.log('推流信息' + result.state + '|' + result.errorCode)
        if (result.errorCode != 0) {
          this.$Message.error('视频推送失败，更换线路')
          this.$confirm('视频服务接入失败，请确认您的网络线路，是否更换线路再次尝试连接?', '选择', {
            distinguishCancelAndClose: true,
            confirmButtonText: '大陆线路',
            cancelButtonText: '港澳台或海外线路',
            type: 'warning',
            center: true
          }).then(() => {
            this.getsdk(1, this.room_id)
          }).catch(action => {
            if (action === 'cancel') {
              this.getsdk(2, this.room_id)
            } else {
              this.go_down = 0
              this.go_up = 0
              this.sec = 0
              this.min = 0
              this.hr = 0
              this.zg_now.logoutRoom(this.room_id)
              this.room_id = 0
              this.$router.push({
                name: 'apply_jobfair'
              })
            }
          })
        }
      })
      zg.on('publishQualityUpdate', (streamID, stats) => {
// 推流质量
      })

      zg.on('playerStateUpdate', result => {
// 处理拉流状态
        console.log('视频流状态：' + result.state + '|' + result.errorCode)
      })

      zg.on('playQualityUpdate', (streamID, stats) => {
        console.log('质量' + streamID + '|' + stats.video.videoQuality)
        console.log('质量' + streamID + '|' + stats.audio.audioQuality)
        console.log('质量' + streamID + '|' + stats.video.videoFPS)
        if (stats.video.videoQuality > 3) {
          this.$Message.error('视频质量差，请检查您的网络')
        }
        if (stats.audio.audioQuality > 3) {
          this.$Message.error('音频质量差，请检查您的网络')
        }

// 拉流质量回调
      })
      var _this = this
      // this.$Message.error('重点代码')
      zg.on('roomStreamUpdate', (roomID, updateType, streamList) => {
        _this.$Message.error('房间有变化状态：' + updateType)
        console.log('房间有变化状态：' + updateType)
        if (updateType == 'ADD') {
          streamList.forEach(async function (value) {
            console.log('数据流：' + value.streamID)
            _this.playsteamid = value.streamID
            const remoteStream = await zg.startPlayingStream(value.streamID)
            _this.$refs.playVideo.pause()
            _this.$refs.playVideo.srcObject = remoteStream
            var day2 = new Date()
            day2.setTime(day2.getTime())
            var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
            _this.room_finfo.Istime = s2
            _this.room_state = 1

            _this.sec = 0
            _this.min = 6
            _this.hr = 0
            _this.go_down = 0
            _this.go_up = 1
            if (_this.time_do == 0) {
              _this.countup()
            }
            _this.roomok()
          })
        }
      })
      // 拉流
      // console.log('数据流：'+value.streamID)
      _this.playsteamid = 's' + roomID
      const remoteStream = await zg.startPlayingStream(_this.playsteamid)
      _this.$refs.playVideo.pause()
      _this.$refs.playVideo.srcObject = remoteStream
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      _this.room_finfo.Istime = s2
      _this.room_state = 1

      _this.sec = 0
      _this.min = 6
      _this.hr = 0
      _this.go_down = 0
      _this.go_up = 1
      if (_this.time_do == 0) {
        _this.countup()
      }
    },
    async videostart (roomID) {
      let appID = parseInt(this.sdk_appid)
      let aoosign = this.sdk_appsign
      let server = this.sdk_server
      console.log(appID + '|' + aoosign + '|' + server)
      let userID = this.formValidate_company.Id.toString()
      let userName = this.formValidate_company.Cname.toString()
      let token = ''
      // let streamID = this.formValidate_company.Id.toString()
      let that = this
      let zg = ''
      if (this.zg_now == '') {
        zg = new ZegoExpressEngine(appID, server)
        this.zg_now = zg
        console.log('sse-' + this.zg_now)
      } else {
        zg = this.zg_now
        console.log('sse-' + this.zg_now)
      }

      // return
      zg.on('roomStateUpdate', async (roomID, state, errorCode, extendedData) => {
        if (state == 'DISCONNECTED') {
          // 与房间断开了连接
          that.ms_state = false
          this.roomout()
        }
        if (state == 'CONNECTING') {
          // 与房间尝试连接中
        }
        if (state == 'CONNECTED') {
          // 与房间连接成功
          that.ms_state = true
          const localStream = await zg.createStream(this.option)
          this.$refs.localVideo.srcObject = localStream

          // 开始推流，将自己的音视频流推送到 ZEGO 音视频云
          let streamID = that.formValidate_company.Id.toString()
          streamID = streamID + '-' + new Date().getTime().toString()
          const repush = zg.startPublishingStream(streamID, localStream)
          if (!repush) {
            this.$Message.error('视频信号传输失败，更换线路')
            this.$confirm('视频服务接入失败，请确认您的网络线路，是否更换线路再次尝试连接?', '选择', {
              distinguishCancelAndClose: true,
              confirmButtonText: '大陆线路',
              cancelButtonText: '港澳台或海外线路',
              type: 'warning',
              center: true
            }).then(() => {
              this.getsdk(1, this.room_id)
            }).catch(action => {
              if (action === 'cancel') {
                this.getsdk(2, this.room_id)
              } else {
                this.go_down = 0
                this.go_up = 0
                this.sec = 0
                this.min = 0
                this.hr = 0
                this.zg_now.logoutRoom(this.room_id)
                this.room_id = 0
                this.$router.push({
                  name: 'apply_jobfair'
                })
              }
            })
          }
        }
      })
      token = this.getZeGouToken(appID, aoosign, userID)
      const result = await zg.loginRoom(roomID, token, { userID, userName }, { userUpdate: true })
      console.log('登录房间' + result)
      if (!result) {
        this.$Message.error('登录失败')
      }
      zg.on('publisherStateUpdate', result => {
// 推流状态变更通知
        console.log('推流信息' + result.state + '|' + result.errorCode)
        if (result.errorCode != 0) {
          this.$Message.error('视频推送失败，更换线路')
          this.$confirm('视频服务接入失败，请确认您的网络线路，是否更换线路再次尝试连接?', '选择', {
            distinguishCancelAndClose: true,
            confirmButtonText: '大陆线路',
            cancelButtonText: '港澳台或海外线路',
            type: 'warning',
            center: true
          }).then(() => {
            this.getsdk(1, this.room_id)
          }).catch(action => {
            if (action === 'cancel') {
            this.getsdk(2, this.room_id)
            } else {
              this.go_down = 0
              this.go_up = 0
              this.sec = 0
              this.min = 0
              this.hr = 0
              this.zg_now.logoutRoom(this.room_id)
              this.room_id = 0
              this.$router.push({
                name: 'apply_jobfair'
              })
            }
          })
        }
      })
      zg.on('publishQualityUpdate', (streamID, stats) => {
// 推流质量
      })

      zg.on('playerStateUpdate', result => {
// 处理拉流状态
        console.log('视频流状态：' + result.state + '|' + result.errorCode)
      })

      zg.on('playQualityUpdate', (streamID, stats) => {
         console.log('质量' + streamID + '|' + stats.video.videoQuality)
        console.log('质量' + streamID + '|' + stats.audio.audioQuality)
        console.log('质量' + streamID + '|' + stats.video.videoFPS)
        if (stats.video.videoQuality > 3) {
          this.$Message.error('视频质量差，请检查您的网络')
        }
        if (stats.audio.audioQuality > 3) {
          this.$Message.error('音频质量差，请检查您的网络')
        }

// 拉流质量回调
      })
      var _this = this
      // this.$Message.error('重点代码')
      zg.on('roomStreamUpdate', (roomID, updateType, streamList) => {
        // _this.$Message.error('房间有变化状态：'+updateType)
        console.log('房间有变化状态：' + updateType)
        if (updateType == 'ADD') {
          streamList.forEach(async function (value) {
            console.log('数据流：' + value.streamID)
            _this.playsteamid = value.streamID
            const remoteStream = await zg.startPlayingStream(value.streamID)
            // _this.$refs.playVideo.pause();
            _this.$refs.playVideo.srcObject = remoteStream
            var day2 = new Date()
            day2.setTime(day2.getTime())
            var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
            _this.room_finfo.Istime = s2
            _this.room_state = 1

            _this.sec = 0
            _this.min = 6
            _this.hr = 0
            _this.go_down = 0
            _this.go_up = 1
            if (_this.time_do == 0) {
              _this.countup()
            }
            _this.roomok()
          })
        } else if (updateType == 'DELETE') {
          // 流删除，停止拉流
          const streamID = streamList[0].streamID
          zg.stopPlayingStream(streamID)
        }
      })

      this.go_down = 1
      // _this.$Message.error('代码位置')
      this.countdown()
    },
    addzero (num) {
      let backstr = '00'
      if (num.toString().length == 1) {
        backstr = '0' + num.toString()
      } else {
        backstr = num.toString()
      }
      return backstr
    },
    btnroomend () {
      this.go_down = 0
      this.go_up = 0
      let that = this
      this.$confirm('面试结束, 您是否有意向录用该求职人员?', '选择', {
        distinguishCancelAndClose: true,
        confirmButtonText: '意向录用',
        cancelButtonText: '无意向录用',
        type: 'warning',
        center: true
      }).then(() => {
        var day2 = new Date()
        day2.setTime(day2.getTime())
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
        that.room_finfo.Ietime = s2
        that.room_finfo.Iresult = 3
        that.room_finfo.State = 1
        that.msg(2)
      }).catch(action => {
        if (action === 'cancel') {
          var day2 = new Date()
          day2.setTime(day2.getTime())
          var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
          that.room_finfo.Ietime = s2
          that.room_finfo.Iresult = 4
          that.room_finfo.State = 1
          that.msg(2)
        } else {
          this.$message({
            type: 'info',
            message: '您未进行选择，请再次选择'
          })
          that.btnroomend()
        }
      })
    },
    perinfo_show (val) {
      this.msgmodal = true
      this.formValidate_per = val
    }

  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getcompanyinfo()
    this.getjoblist()
    window.addEventListener('beforeunload', e => {
      this.beforeunloadHandler(e)
      // this.unloadHandler()
    })
    window.addEventListener('unload', async e => {
      this.unloadHandler(e)
    })
    this.setDuration()
  }

}

</script>

<style rel="stylesheet/scss" lang="scss">
.el-drawer {

  overflow: scroll
}

</style>

<style lang="less" scoped>

.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}

</style>
